<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  name: 'AppWeekday',
  props: {
    value: {
      type: String,
      validator(value) {
        return [
          'sunday',
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
        ].includes(value)
      },
    },
  },
  computed: {
    text() {
      switch (this.value) {
        case 'sunday':
          return '日曜日'
        case 'monday':
          return '月曜日'
        case 'tuesday':
          return '火曜日'
        case 'wednesday':
          return '水曜日'
        case 'thursday':
          return '木曜日'
        case 'friday':
          return '金曜日'
        case 'saturday':
          return '土曜日'
        default:
          throw new Error('Invalid weekday name')
      }
    },
  },
}
</script>

<style></style>
